module.exports = __webpack_public_path__ + "static/img/dia-01.832c0f2.png";